import { useContext } from "react";
import InvoicingContext from "./InvoicingContext";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";

function useDetailHandlers({ onDetailSuccess, setSelectedDetail }) {
    const dispatch = useDispatch();

    const { InvoiceDetails } = useContext(InvoicingContext);

    const onSuccess = (form) => {
        dispatch(notifySuccess("Service saved successfully!"));
        form.setSubmitting(false);
        form.resetForm();
        setSelectedDetail(undefined);
    };

    const onError = (error, form) => {
        form.setSubmitting(false);
        dispatch(notifyError(error.message));
    };

    const onSaveHandler = (values, form) => {
        const { invoiceId, id, unitPrice, quantity, productId, notes } = values;
        const apiCall = id ? InvoiceDetails.update : InvoiceDetails.add;
        const payload = {
            invoiceId,
            id,
            unitPrice: Number(unitPrice),
            quantity: Number(quantity),
            productId: String(productId),
            notes,
        };
        form.setSubmitting(true);
        apiCall({
            payload,
            onSuccess: (newId) => {
                onSuccess(form);
                onDetailSuccess(newId, payload);
            },
            onError: (error) => onError(error, form),
        });
    };

    return {
        onSaveHandler,
    };
}

export default useDetailHandlers;
